import React, { useEffect, useState }  from "react";
import { useForm } from "react-hook-form";
import { GetFormTemplateData, editCascadingFieldsHandler } from "../../common/controlHelper";
import SlbPopUp from "../controls/slbPopUp";
import { RenderForm } from "../jsonSchemaForm/formRenderer";
import { useDispatch } from "react-redux";
import { ComponentLoader } from "../loader/componentLoader";

const _props = {
    show: false,
    setShowPopup: () => { },
    title: '',
    onAddClick: () => { },
    form: {},
    fields: [],
    row: {},
    actions: { ok: { label: '' }, cancel: { label: '' } }
}

export function UpdateListItemPopup(props = _props) {
    const dispatch = useDispatch();
    const [editFields, setEditFields] = useState([]);
    const [cascadedFields, setCascadedFields] = useState([]);
    const [isUploadComplete,setIsUploadComplete] = useState(true);
    const rowId = props?.row?._id;

    useEffect(() => {
        const fetchData = async () => {
            const fields = await editCascadingFieldsHandler(props.fields, props.row, dispatch);
            setCascadedFields(fields);
            const editCascadedFields = fields.filter(x => x.edit && x.edit.enabled).map(x => { return { ...x.edit, field: x.field } });
            setEditFields(editCascadedFields)
            const data = GetFormTemplateData(fields, props.row);
            const finalData = {...data,id: rowId, actionType: rowId ? 'edit' : 'create'};
            return finalData;
        };
        fetchData().then((data) => {
            form.reset(data);
        });
    }, [props.fields, props.row, dispatch, rowId]);

    const form = useForm({defaultValues: {}});

    function processData(formData) {
        props.onAddClick(formData);
    }

    function handleUploadComplete(isDocReady){
        setIsUploadComplete(isDocReady)
    }

    return (
        <SlbPopUp
            show={props.show}
            title={!editFields.length>0?"Loading...":props.title}
            buttons={
                {
                    cancel: {
                        label: props.actions.cancel.label, onClick: (event) => {
                            form.reset();
                            props.setShowPopup(false);
                        }
                    },
                    ok: editFields.length>0 ? {
                        label: props.actions.ok.label, onClick: (event) => {
                            form.handleSubmit(processData)();
                        },
                        disabled: !isUploadComplete,
                    } : {}

                }
            }
        >
            {editFields.length>0 ? <RenderForm existingDocInfo={props.row} setIsUploadComplete={handleUploadComplete} form={form} fields={cascadedFields} />:<ComponentLoader/>}
        </SlbPopUp>
    );
}